import React from 'react'
import {useTranslation} from 'react-i18next'
import {Button, Col, Modal, Row, Typography} from 'antd'
import classNames from 'classnames'

import {useScreenType} from '@/hooks'
import styles from './BankAccountCard.scss'

type BankAccountDeleteModalProps = {
    open: boolean
    isDeleting: boolean
    onConfirm: () => void
    onCancel: () => void
}

export const BankAccountDeleteModal: React.FC<BankAccountDeleteModalProps> = ({
    open,
    isDeleting,
    onConfirm,
    onCancel
}) => {
    const {t} = useTranslation()
    const {isMobile} = useScreenType()

    return (
        <Modal
            className={styles.modal}
            open={open}
            title={
                <Typography.Title level={3} className={styles.modalTitle}>
                    {t('BankAccountCard.titles.removeBankAccount')}
                </Typography.Title>
            }
            closable={false}
            onCancel={onCancel}
            footer={
                <Row justify={'space-between'} className={styles.modalFooter}>
                    <Col>
                        <Button
                            type={'primary'}
                            size={'large'}
                            loading={isDeleting}
                            onClick={onConfirm}
                            className={classNames(styles.modalButton, {[styles.modalButtonMobile]: isMobile})}
                        >
                            {t('BankAccountCard.buttons.remove')}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            size={'large'}
                            disabled={isDeleting}
                            onClick={onCancel}
                            className={classNames(styles.modalButton, {[styles.modalButtonMobile]: isMobile})}
                        >
                            {t('BankAccountCard.buttons.cancel')}
                        </Button>
                    </Col>
                </Row>
            }
        >
            {t('BankAccountCard.messages.removeConfirmation')}
        </Modal>
    )
}
